import React, { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { peopleSpeak, trafficCone } from 'assets/icon';
import { Typography } from '../alf-design';
import { myslideLogo, maintenance } from '../../assets/img';
import Background from './Background';
import Footer from './Footer';

const MaintenancePage = () => {
  useEffect(() => {
    datadogRum.addAction('maintenance.page.viewed');
  }, []);

  const renderCircleIcon = (icon) => (
    <img alt="" src={icon} className="w-1/2 lg:w-auto" />
  );

  return (
    <Background>
      <main id="public-main-content" role="main">
        <div className="flex justify-self-start lg:justify-self-center m-[12px] lg:mt-[30px]">
          <img
            src={myslideLogo}
            alt="mySlide"
            className="w-[80px] lg:mb-0 lg:w-[280px]"
          />
        </div>
        <div className="flex flex-col min-h-[70vh] w-full lg:grid lg:grid-cols-2 items-center justify-around lg:justify-between">
          <div className="flex text-center lg:justify-self-end lg:mx-[56px]">
            <img
              src={maintenance}
              alt="maintenanceImg"
              className="my-[3%] w-[271px] lg:w-[471px]"
            />
          </div>
          <div className="flex flex-col gap-[18px] lg:gap-[56px] my-[25px] lg:mt-0">
            <div className="flex flex-row items-center gap:[35px] lg:gap-[56px] mr-[25px] lg:mr-0 ml-[25px] lg:ml-0">
              <div className="text-center lg:text-left">
                {renderCircleIcon(trafficCone)}
              </div>
              <div className="w-[250px] lg:w-[50%]">
                <Typography
                  type="h2"
                  component="h2"
                  className="!mb-0 !text-[18px]"
                >
                  System Maintenance
                </Typography>
                <Typography
                  component="p"
                  className="!text-[11px] !leading-normal"
                >
                  mySlide is undergoing scheduled maintenance. <br />
                  Access and tools will not be available during this time.
                </Typography>
              </div>
            </div>
            <div className="flex flex-row items-center gap:[35px] lg:gap-[56px] mr-[25px] lg:mr-0 ml-[25px] lg:ml-0">
              <div className="text-center lg:text-left">
                {renderCircleIcon(peopleSpeak)}
              </div>
              <div className="w-[250px] lg:w-[50%]">
                <Typography
                  type="h2"
                  component="h2"
                  className="!mb-0 !text-[18px]"
                >
                  Customer Service
                </Typography>
                <Typography
                  component="p"
                  className="!text-[11px] !leading-normal"
                >
                  If you have any questions or need help with your account, call
                  customer service at (800) 748-2030. Available Monday - Friday,
                  8am - 5pm EST
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </Background>
  );
};

export default MaintenancePage;
